/* unplugin-vue-components disabled */import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=41603ad4&lang=css"

const __exports__ = script;

export default __exports__